<div data-test="aviation-liabilities-form"
     [formGroup]="form()"
>
  <p-accordion data-test="aviation-liabilities-accordion"
               [multiple]="true"
               [value]="activePanels()"
               (valueChange)="onActivePanelsChange($event)"
  >
    <p-accordion-panel class="accordion-panel-scroll-target"
                       data-test="general-liabilities-info-panel"
                       [value]="generalPanel"
    >
      <div #subPanel
           class="accordion-panel-scroll-target"
           [attr.data-index]="nav.getSectionIndex(mainIndex()!)"
      ></div>
      <p-accordion-header data-test="general-liabilities-info-header">
        <p class="section-title"> General Information </p>
      </p-accordion-header>
      <p-accordion-content data-test="general-liabilities-info-content">
        @if (activePanels().includes(generalPanel)) {
          <div class="comparison-grid expanded-mode"
               data-test="general-liabilities-comparison-grid"
               [formGroup]="form().controls.general"
          >
            <!-- Period Row -->
            <div class="origami-field">
              <albert-period controlName="externalValue"
                             data-test="external-general-liabilities-period"
                             periodFromGroupName="periodFrom"
                             periodFromInputId="ext_liabilities_periodFrom"
                             periodFromLabel="Period From"
                             periodToGroupName="periodTo"
                             periodToInputId="ext_liabilities_periodTo"
                             periodToLabel="Period To"
                             [disabled]="true"
              />
            </div>
            <div class="override-cell">
              <albert-override-wrapper data-test="override-wrapper-general-liabilities-period"
                                       tooltipLabel="Period"
                                       [disabled]="!canEdit()"
                                       [isVisible]="isFieldVisible('general.periodFrom') || isFieldVisible('general.periodTo')"
                                       (visibilityChange)="toggleField('general.periodFrom'); toggleField('general.periodTo')"
              >
                <albert-period controlName="localValue"
                               data-test="local-general-liabilities-period"
                               periodFromGroupName="periodFrom"
                               periodFromInputId="loc_liabilities_periodFrom"
                               periodFromLabel="Period From"
                               periodToGroupName="periodTo"
                               periodToInputId="loc_liabilities_periodTo"
                               periodToLabel="Period To"
                               [disabled]="!canEdit()"
                />
              </albert-override-wrapper>
            </div>
          </div>
        }
      </p-accordion-content>
    </p-accordion-panel>

    <albert-sub-coverage-panels [activePanels]="activePanels()"
                                [form]="form()"
                                [isCreateMode]="isCreateMode()"
                                [mainIndex]="mainIndex()"
                                [memberExternalId]="memberExternalId()"
                                [panels]="panels"
                                [policyStatus]="policyStatus()"
    >
      <ng-template let-panel>
        @if (panel.key === 'aviationThirdPartyWarExcessLiability') {
          <albert-aircraft-limit-list class="block mt-6"
                                      [canEdit]="canEdit()"
                                      [form]="form().controls.aviationThirdPartyWarExcessLiability"
          />
        }
      </ng-template>
    </albert-sub-coverage-panels>
  </p-accordion>
</div>
